import React, { useState } from 'react';
import { Grid } from 'semantic-ui-react';

import GridColumnInputWrapper from '../../../common/GridColumnInputWrapper';
import { AccordionWrapper, InputWrapper } from 'react-lib/dist/components-es';

const CPChemicalOtherContainer = props => {
  const hasAnyValue = chemicalProduct => {
    return !!chemicalProduct?.formula || !!chemicalProduct?.purity;
  };

  const [isInitiallyCollapsed, setIsInitiallyCollapsed] = useState(
    !hasAnyValue(props.values.chemicalProduct)
  );

  const getContainerContent = () => {
    const { values, disabled, chemicalProductDisabled } = props;

    return (
      <Grid stackable columns={2} verticalAlign="bottom">
        <GridColumnInputWrapper
          {...props}
          disabled={disabled || chemicalProductDisabled}
          value={values.chemicalProduct.formula || ''}
          name="chemicalProduct.formula"
          label="chemical.product.details.page.chemical.other.container.formula.input"
          render={props => <InputWrapper {...props} type="text" />}
        />
        <GridColumnInputWrapper
          {...props}
          disabled={disabled || chemicalProductDisabled}
          value={values.chemicalProduct.purity || ''}
          name="chemicalProduct.purity"
          label="chemical.product.details.page.chemical.other.container.purity.input"
          render={props => <InputWrapper {...props} type="text" />}
        />
      </Grid>
    );
  };

  return (
    <AccordionWrapper
      {...props}
      closable={true}
      collapsed={isInitiallyCollapsed}
      accordionTitle="chemical.product.details.page.chemical.other.container.title"
      render={getContainerContent}
      className=""
    />
  );
};

export default CPChemicalOtherContainer;
